export enum ButtonDisplayMode {
  CHALLENGES = 'challenges',
  SUBMIT_IDEA = 'submitIdea',
  CUSTOM = 'custom',
  NONE = 'none'
}
